var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "w-dialog",
    {
      ref: "wDialog",
      attrs: {
        border: false,
        closeFree: "",
        top: _vm.popTop,
        width: "836px",
        title: _vm.title,
      },
      on: { ok: _vm.selectOk, cancel: _vm.cancel },
      model: {
        value: _vm.visible,
        callback: function ($$v) {
          _vm.visible = $$v
        },
        expression: "visible",
      },
    },
    [
      _c("div", { staticClass: "picker" }, [
        _c(
          "div",
          { staticClass: "candidate" },
          [
            _c("div", { staticClass: "selected-title" }, [
              _c("div", { staticClass: "title-name" }, [_vm._v("请选择")]),
            ]),
            _vm.tabsType != "user" &&
            _vm.tabsType != "resign" &&
            _vm.tabsType != "role" &&
            _vm.tabsType != "dept"
              ? _c(
                  "el-tabs",
                  {
                    staticClass: "custom-tabs",
                    attrs: { type: "card", size: "small" },
                    on: { "tab-click": _vm.toggleTab },
                    model: {
                      value: _vm.activeName,
                      callback: function ($$v) {
                        _vm.activeName = $$v
                      },
                      expression: "activeName",
                    },
                  },
                  [
                    _c("el-tab-pane", {
                      attrs: { label: "部门", name: "dept" },
                    }),
                    _c("el-tab-pane", {
                      attrs: { label: "员工", name: "user" },
                    }),
                    _c("el-tab-pane", {
                      attrs: { label: "角色", name: "role" },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm.activeName == "resign"
              ? _c(
                  "el-tabs",
                  {
                    staticClass: "custom-tabs",
                    attrs: { type: "card", size: "small" },
                    on: { "tab-click": _vm.toggleStatusTab },
                    model: {
                      value: _vm.employmentStatus,
                      callback: function ($$v) {
                        _vm.employmentStatus = $$v
                      },
                      expression: "employmentStatus",
                    },
                  },
                  [
                    _c("el-tab-pane", {
                      attrs: { label: "在职员工", name: "active" },
                    }),
                    _c("el-tab-pane", {
                      attrs: { label: "离职员工", name: "resigned" },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.activeName === "dept",
                    expression: "activeName === 'dept'",
                  },
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading,
                    expression: "loading",
                  },
                ],
                staticClass: "org-items org-items-dept",
                style: _vm.leftDeptHeight,
              },
              [
                _c("el-tree", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.nodes.length != 0,
                      expression: "nodes.length != 0",
                    },
                  ],
                  ref: "treeDept",
                  attrs: {
                    data: _vm.nodes,
                    "show-checkbox": "",
                    "check-strictly": true,
                    "node-key": "id",
                    "default-checked-keys": _vm.checkDept,
                    props: _vm.defaultProps,
                  },
                  on: { "check-change": _vm.selectChange },
                }),
              ],
              1
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      _vm.activeName === "user" || _vm.activeName === "resign",
                    expression:
                      "activeName === 'user' || activeName === 'resign'",
                  },
                ],
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "search-user-con",
                    class: "search-user-con-" + _vm.employmentStatus,
                  },
                  [
                    _c("el-cascader", {
                      ref: "cascaderDept",
                      staticClass: "input-1",
                      attrs: {
                        options: _vm.deptList,
                        "show-all-levels": false,
                        size: "medium",
                        placeholder: "选择部门",
                        props: {
                          checkStrictly: true,
                          label: "orgName",
                          value: "orgPath",
                          children: "children",
                        },
                        clearable: "",
                        filterable: "",
                      },
                      on: { change: _vm.searchUserOrg },
                      model: {
                        value: _vm.searchForm.orgId,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "orgId", $$v)
                        },
                        expression: "searchForm.orgId",
                      },
                    }),
                    _c("el-input", {
                      staticClass: "input-2",
                      attrs: {
                        placeholder: "搜索员工",
                        "prefix-icon": "el-icon-search",
                        size: "medium",
                        clearable: "",
                      },
                      on: { input: _vm.debouncedGetOrgList },
                      model: {
                        value: _vm.searchForm.keyword,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "keyword", $$v)
                        },
                        expression: "searchForm.keyword",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.loading,
                        expression: "loading",
                      },
                    ],
                    staticClass: "org-items org-items-user",
                    style: _vm.leftHeight,
                  },
                  [
                    _vm.multiple
                      ? _c(
                          "el-checkbox-group",
                          {
                            model: {
                              value: _vm.checkUser,
                              callback: function ($$v) {
                                _vm.checkUser = $$v
                              },
                              expression: "checkUser",
                            },
                          },
                          _vm._l(_vm.nodes, function (item, index) {
                            return _c(
                              "el-checkbox",
                              {
                                key: index,
                                staticClass: "item-user",
                                attrs: {
                                  label: item.sysUserId,
                                  disabled: _vm.defaultUserIds.includes(
                                    item.sysUserId
                                  ),
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.selectChange(item, $event)
                                  },
                                },
                              },
                              [
                                _c("div", { staticClass: "name-con" }, [
                                  _c("span", { staticClass: "no" }, [
                                    _vm._v(_vm._s(item.serial)),
                                  ]),
                                  _c("span", { staticClass: "name" }, [
                                    _vm._v(_vm._s(item.reallyName)),
                                  ]),
                                  _c("span", { staticClass: "phone" }, [
                                    _vm._v(
                                      "(" + _vm._s(item.phoneNumber) + ")"
                                    ),
                                  ]),
                                ]),
                                _c("div", { staticClass: "org-con" }, [
                                  _c("span", { staticClass: "org" }, [
                                    _vm._v("(" + _vm._s(item.orgName) + ")"),
                                  ]),
                                ]),
                              ]
                            )
                          }),
                          1
                        )
                      : _c(
                          "el-radio-group",
                          {
                            model: {
                              value: _vm.checkUser[0],
                              callback: function ($$v) {
                                _vm.$set(_vm.checkUser, 0, $$v)
                              },
                              expression: "checkUser[0]",
                            },
                          },
                          _vm._l(_vm.nodes, function (item, index) {
                            return _c(
                              "el-radio",
                              {
                                key: index,
                                staticClass: "item-user",
                                attrs: { label: item.sysUserId },
                                on: {
                                  change: function ($event) {
                                    return _vm.selectChange(item, $event)
                                  },
                                },
                              },
                              [
                                _c("div", { staticClass: "name-con" }, [
                                  _c("span", { staticClass: "no" }, [
                                    _vm._v(_vm._s(item.serial)),
                                  ]),
                                  _c("span", { staticClass: "name" }, [
                                    _vm._v(_vm._s(item.reallyName)),
                                  ]),
                                  _c("span", { staticClass: "phone" }, [
                                    _vm._v(
                                      "(" + _vm._s(item.phoneNumber) + ")"
                                    ),
                                  ]),
                                ]),
                                _c("div", { staticClass: "org-con" }, [
                                  _c("span", { staticClass: "org" }, [
                                    _vm._v("(" + _vm._s(item.orgName) + ")"),
                                  ]),
                                ]),
                              ]
                            )
                          }),
                          1
                        ),
                    _vm.totalNum == 0
                      ? _c("el-empty", {
                          attrs: {
                            "image-size": 100,
                            description: "找不到相关员工",
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ]
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.activeName === "role",
                    expression: "activeName === 'role'",
                  },
                ],
              },
              [
                _c(
                  "div",
                  { staticClass: "search-user-con" },
                  [
                    _c("el-input", {
                      staticClass: "input-3",
                      attrs: {
                        placeholder: "搜索角色",
                        "prefix-icon": "el-icon-search",
                        size: "medium",
                        clearable: "",
                      },
                      on: { input: _vm.debouncedGetOrgList },
                      model: {
                        value: _vm.searchForm.roleName,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "roleName", $$v)
                        },
                        expression: "searchForm.roleName",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.loading,
                        expression: "loading",
                      },
                    ],
                    staticClass: "org-items org-items-user org-items-role",
                    style: _vm.leftHeight,
                  },
                  [
                    _c(
                      "el-checkbox-group",
                      {
                        model: {
                          value: _vm.checkRole,
                          callback: function ($$v) {
                            _vm.checkRole = $$v
                          },
                          expression: "checkRole",
                        },
                      },
                      _vm._l(_vm.nodes, function (item, index) {
                        return _c(
                          "el-checkbox",
                          {
                            key: index,
                            staticClass: "item-user",
                            attrs: { label: item.id },
                            on: {
                              change: function ($event) {
                                return _vm.selectChange(item, $event)
                              },
                            },
                          },
                          [
                            _c("div", { staticClass: "name-con" }, [
                              _vm._v(_vm._s(item.name)),
                            ]),
                          ]
                        )
                      }),
                      1
                    ),
                    _vm.totalNum == 0
                      ? _c("el-empty", {
                          attrs: {
                            "image-size": 100,
                            description: "找不到相关角色",
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ]
            ),
          ],
          1
        ),
        _c("div", { staticClass: "selected" }, [
          _c("div", { staticClass: "selected-title" }, [
            _c("div", { staticClass: "title-name" }, [_vm._v("已选择")]),
            _c("div", { staticClass: "count" }, [
              _vm._v(_vm._s(_vm.select.length)),
            ]),
          ]),
          _c(
            "div",
            { staticClass: "org-items" },
            [
              _vm.select.length === 0
                ? _c("el-empty", {
                    attrs: {
                      "image-size": 100,
                      description: "请点击左侧列表选择数据",
                    },
                  })
                : _c(
                    "div",
                    { staticClass: "selected-list" },
                    _vm._l(_vm.select, function (org, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass: "item",
                          class: {
                            "item-disabled": org.disabled,
                            "item-single": !_vm.multiple,
                          },
                        },
                        [
                          _c("span", { staticClass: "name" }, [
                            _vm._v(_vm._s(org.serial) + _vm._s(org.name)),
                          ]),
                          _c("i", {
                            staticClass: "el-icon-close",
                            on: {
                              click: function ($event) {
                                return _vm.noSelected(org)
                              },
                            },
                          }),
                        ]
                      )
                    }),
                    0
                  ),
            ],
            1
          ),
        ]),
      ]),
      _vm.actionType == "transferUser"
        ? _c(
            "div",
            [
              _c(
                "el-form",
                {
                  staticClass: "change-form",
                  attrs: { "label-width": "80px" },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "发起人备注" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          placeholder: "请输入",
                          rows: 2,
                          maxlength: "64",
                          "show-word-limit": "",
                        },
                        model: {
                          value: _vm.remarks,
                          callback: function ($$v) {
                            _vm.remarks = $$v
                          },
                          expression: "remarks",
                        },
                      }),
                      _c("div", { staticClass: "hot" }, [
                        _vm._v("转移后原归属人将不可编辑该信息"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.actionType == "changeUser"
        ? _c(
            "div",
            [
              _c(
                "el-form",
                {
                  staticClass: "change-form",
                  attrs: { "label-width": "80px" },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "转交备注" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          placeholder: "请输入",
                          rows: 2,
                          maxlength: "64",
                          "show-word-limit": "",
                        },
                        model: {
                          value: _vm.comment,
                          callback: function ($$v) {
                            _vm.comment = $$v
                          },
                          expression: "comment",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm.actionType == "addUser"
        ? _c(
            "div",
            [
              _c(
                "el-form",
                {
                  staticClass: "change-form",
                  attrs: { "label-width": "80px" },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "加签方式" } },
                    [
                      _c(
                        "el-radio",
                        {
                          attrs: { label: "BEFORE" },
                          model: {
                            value: _vm.signType,
                            callback: function ($$v) {
                              _vm.signType = $$v
                            },
                            expression: "signType",
                          },
                        },
                        [_vm._v("前加签")]
                      ),
                      _c(
                        "el-radio",
                        {
                          attrs: { label: "AFTER" },
                          model: {
                            value: _vm.signType,
                            callback: function ($$v) {
                              _vm.signType = $$v
                            },
                            expression: "signType",
                          },
                        },
                        [_vm._v("后加签")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "加签备注" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          placeholder: "请输入",
                          rows: 2,
                          maxlength: "64",
                          "show-word-limit": "",
                        },
                        model: {
                          value: _vm.comment,
                          callback: function ($$v) {
                            _vm.comment = $$v
                          },
                          expression: "comment",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.signType === "AFTER",
                          expression: "signType === 'AFTER'",
                        },
                      ],
                      attrs: { label: "审批通过备注" },
                      scopedSlots: _vm._u([
                        {
                          key: "label",
                          fn: function () {
                            return [
                              _c("div", { staticClass: "lable-title" }, [
                                _vm._v("审批通过"),
                                _c("br"),
                                _vm._v("备注"),
                              ]),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          placeholder: "请输入",
                          rows: 2,
                          maxlength: "64",
                          "show-word-limit": "",
                        },
                        model: {
                          value: _vm.approveComment,
                          callback: function ($$v) {
                            _vm.approveComment = $$v
                          },
                          expression: "approveComment",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }